import { PLAY_PODCAST_PAGE_ROOT_URL } from './constants';

export function createPodcastPageRedirectLink(podcastId: string | undefined) {
  if (!podcastId) return undefined;
  return `${PLAY_PODCAST_PAGE_ROOT_URL}/${podcastId}`;
}
